<template>
  <div>
    <a href="https://arxiv.org/pdf/2503.22113"
      >Briteller: Shining a Light on AI Recommendation for Children</a
    >
    <br />
    Briteller: a light-based tangible interface designed to teach children AI
    recommender system’s core algorithmic building block, the dot product,
    through hands-on interactions
    <br />How it works: <br />Initial version: <br />Uses optical materials to
    physically represent data vectors and the dot product. Light intensity
    (DARK-BRIGHT) encodes attribute values, while merging beams (MERGING) and
    blocking light (BLOCKAGE) embody multiplication and addition operations.
    <br />AR-Enhanced version: <br />Addresses limitations by overlaying numeric
    labels, contextualizing recommendations (e.g., food items), and enabling
    dynamic expansion of data attributes via tablet-based AR
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.22573">
      A Framework for Cryptographic Verifiability of End-to-End AI Pipelines</a
    >
    <br />
    cryptographic framework to ensure transparency and trust:
    <br />Data authenticity: C2PA standards <br />Model training: Zero-Knowledge
    Proofs of Training (ZKPoTs) ensure no revealing sensitive data <br />Model
    inference: Zero-Knowledge Proofs of Inference (ZKPoIs) confirm outputs were
    generated by a specific model. <br />Unlearning: Zero-Knowledge Proofs of
    Unlearning (ZKPoUs) verify data removal for compliance with privacy laws
    <br />
    <br />challenges: <br />Current solutions verify isolated steps but fail to
    cryptographically link them. <br />Cannot verify transformations. <br />ZKPs
    often require revealing the model structure, limiting confidentiality.
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.15668"
      >Model Risk Management for Generative AI In Financial Institutions</a
    >
    <br />
    Good:
    <br />GenAI models can play a pivotal role in scanning transactions with
    other institutions, market news, asset prices and other proprietary
    information and assets to provide customized solutions to risk management
    <br />Bad: <br />a. cost in terms of computational power and human talent,
    <br />b. heightened risk from the ethical implications and potential biases
    inherent in AI systems <br />c. potential vulnerabilities to malicious
    exploitation <br />
    <br />
    Application:
    <br />Used for: summarization, retrieval-augmented generation (RAG), and
    general content creation <br />Risk: model risk and non-model risk <br />
    <br />
    Model Risk Management for GenAI models:
    <br />1. Initial Risk Assessment <br />2. Model Development and Validation
    Standards: <br />2.1 Conceptual Soundness (CS): <br />
    CS Review #1 - LLM literature review and selection rationale <br />
    CS Review #2 - Data quality check <br />
    CS Review #3 –Model specification <br />
    CS Review #4 - Model explainability <br />CS Review #5 -Fairness testing
    <br />CS Review #6 - Benchmarking <br />2.2 Outcome Analysis(OA): <br />OA
    Review #1 - Performance metrics and model output replication <br />OA Review
    #2 - Model robustness and overfitting <br />OA Review #3 -Detect model error
    patterns. <br />OA Review #4 – Hallucination detection <br />OA Review #5 –
    Toxicity detection <br />3. Implementation Testing and Model Use: <br />User
    Control – Restrict access to trained personnel with risk awareness.
    <br />Usage Control – Lock down model use to specific approved tasks only.
    <br />Human-in-the-loop Control – Require human review before using
    AI-generated outputs for decisions. <br />Terms of Use Alerts – Provide
    disclaimers or alerts about model limitations. <br />Input & Output Controls
    <br />4. Ongoing Monitoring & Compliance: prevent degradation
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.15703"
      >Predicting Multi-Agent Specialization via Task Parallelizability</a
    >
    <br />
    Background:
    <br />Multi-agent systems often rely on specialized agents with distinct
    roles rather than generalpurpose agents that perform the entire task
    independently. However, the conditions that govern the optimal degree of
    specialization remain poorly understood <br /><br />
    What:
    <br />we propose that specialist teams outperform generalist ones when
    environmental constraints limit task parallelizability; <br />validate this
    heuristic through three multi-agent reinforcement learning (MARL)
    experiments in Overcooked-AI; <br />We also observe that as the state space
    expands, agents tend to converge on specialist strategies, even when
    generalist ones are theoretically more efficient, highlighting potential
    biases in MARL training algorithms <br /><br />
    Basics:
    <br />Amdahl’s Law: the overall performance improvement gained by optimizing
    a single part of a system is limited by the fraction of time that the
    improved part is actually used
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.15752"
      >Using Language Models to Decipher the Motivation Behind Human
      Behaviors</a
    >
    <br />
    AI presents a unique, new, and powerful way to understand the motivations
    behind behaviors
    <br />
    Why:
    <br />AI can emulate the spectrum and distribution of human behaviors
    <br />the way in which AI’s behavior can be steered is via the prompts that
    it is given. <br /><br />
    How:
    <br />prompt a large language model (LLM) to play a spectrum of classic
    economic games <br />five games: a dictator game, an ultimatum game, an
    investment game, a public goods game, and a risky choice game with seven
    distinct scenarios <br />obtain human-playing data from the MobLab Classroom
    economics experiment platform <br />elicit a distribution of LLM responses
    that try to match the observed behavior <br /><br />
    Novel Approach: The paper introduces a method to decipher human motivations
    behind behaviors using large language models (LLMs). By varying prompts, the
    authors elicit a wide range of human-like behaviors in economic games and
    analyze the prompts to infer underlying motivations.
    <br />Behavioral Codes: The study generates "behavioral codes" (system
    prompts) that elicit specific behaviors in LLMs. These codes reveal general
    motivations (e.g., fairness, risk aversion) without explicitly referencing
    the game or behavior. <br />Matching Human Behavior: The LLM, when prompted
    with these behavioral codes, produces behavior distributions that closely
    match those observed in human experiments across seven classic economic
    games (e.g., Dictator Game, Ultimatum Game). <br />Interpretability:
    Keywords in the behavioral codes (e.g., "generous," "risk-averse") are
    predictive of the elicited behaviors, validated through regression analysis
    and principal component analysis (PCA). <br />Game Relationships: The study
    maps games into a semantic space based on shared behavioral codes, revealing
    intuitive clusters (e.g., risk-related games like the Bomb Game and Investor
    Game group together). <br />Population Signatures: Behavioral codes can
    characterize different populations (e.g., students vs. non-students,
    high-income vs. small-scale societies), highlighting distinct
    decision-making tendencies.
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.15867"
      >TruthLens: Explainable DeepFake Detection for Face Manipulated and Fully
      Synthetic Data</a
    >
    <br />
    existing methods are often limited to binary classification (real vs. fake)
    and lack interpretability
    <br /><br />
    TruthLens, a new framework for detecting and explaining DeepFakes.
    <br /><br />
    Foundation Models:
    <br />DINOv2: vision-only foundation model, designed to learn robust visual
    features through self-supervised learning. <br />PaliGemma2: MLLM designed
    for vision-language tasks, integrating advanced capabilities in both image
    and text processing. <br /><br />
    Feature Mixing:
    <br />combine features from both DINOv2 and PaliGemma2 to leverage their
    complementary strengths in capturing localized and global visual
    information. <br /><br />
    Two-Stage Training:
    <br />Adapter Training: train a one-layer DINOv2 adapter module using the
    LLaVA-Pretrain LCS-558K image captioning dataset. <br />LLM Finetuning:
    finetune the LLM of PaliGemma2 using the Mixture of Features (MoF) vision
    embeddings and question-answer pairs derived from language-annotated
    DeepFake datasets.
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.15896"
      >WeirdFlows: Anomaly Detection in Financial Transaction Flows</a
    >
    <br />
    WeirdFlows, a top-down search pipeline for detecting fraudulent financial
    transactions using network analysis
    <br /><br />
    The WeirdFlows pipeline requires neither an a priori set of patterns nor a
    training set.
    <br /><br />
    How it works:
    <br />create a transaction network using financial transactions data;
    <br />Generate multiple weighted directed temporal networks by aggregating
    wire transfers over time; <br />Uses a depth-first search (DFS) variation to
    find all possible transaction paths up to a given length. <br />Measures the
    weight of each flow by aggregating the minimum transaction values along
    paths. <br />Tracks changes in flow weights over time using statistical
    methods like moving averages (WMA, EWMA). <br />Detects anomalies by
    comparing the actual flow weight to the expected value, identifying sudden
    deviations.
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.16423"
      >GAEA: A Geolocation Aware Conversational Model</a
    >
    <br />
    introduce GAEA to geolocalize images via LMM:
    <br />
    GAEA model: a conversational chatbot that goes beyond global-scale
    geolocalization and provides information about the location described by an
    image.
    <br />GAEA-1.6M: a new dataset for training conversational image
    geolocalization models. <br />800K images and 1.6M question-answer pairs,
    sourced from OpenStreetMap (OSM) metadata and other geolocalization
    datasets. <br />GAEA-Bench: evaluate conversational capabilities in
    geolocal-ization setting; <br />4K image-text pairs; <br />Short Visual
    Question-Answer (SVQA), Multiple Choice (MCQ), True/False (T/F), Long Visual
    Question-Answer (LVQA) <br />quantitatively compare the performance of the
    model to 8 state-of-the-art open-source, and 3 proprietary LMMs, including
    GPT-4o and Gemini-2.0-Flash
  </div>
  <v-divider></v-divider>

  <div>
    <a href="https://arxiv.org/pdf/2503.16288">
      Overview of Variable Rate Coding in JPEG AI
    </a>
    <br />
    JPEG AI standard: learned image compression to outperform traditional codecs
    <br />
    variable rate coding: enabling efficient compression with adaptable quality
    and bit allocation
    <br />

    JPEG AI Standard:
    <br />
    First learning-based image codec standard for mobile devices like
    smartphones, tablets, and other portable electronics.
    <br />

    high compression efficiency while compatible with software and hardware
    systems.
    <br />
    Variable Rate Coding Techniques:
    <br />
    Three-Dimensional (3D) Quality Map:

    <br />
    Supports fine-tuned control of compression: channel-wise (color components)
    and spatial (region-based) levels.

    <br />
    Allows region of interest (ROI) to receive higher quality by allocating more
    bits.

    <br />
    Bit Rate Matching (BRM) Algorithm:

    <br />
    compressed image meets a target bit rate within 10% accuracy.

    <br />
    multi-model approach to cover a broad range of bit rates with minimal
    performance loss.

    <br />
    Variable Rate Training Strategy:

    <br />
    Four models are trained with different Lagrange multipliers to optimize the
    balance between rate and distortion.
    <br />
    Architecture:
    <br />
    Based on an autoencoder with a hyperprior model for learned image
    compression.

    <br />
    Uses a Conditional Color Separation (CCS) framework to efficiently encode
    luminance (Y) and chrominance (UV) separately.
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.16392">
      Graph of Effort: Quantifying Risk of AI Usage for Vulnerability Assessment
    </a>
    <br />
    The paper introduces the Graph of Effort (GOE), a new method to quantify the
    effort required to exploit vulnerabilities using offensive AI (OAI) by
    adversaries.
    <br />
    <br />
    OAI: use AI to attack non-AI assets
    <br />
    1. Direct attacks using AI
    <br />
    2. Adversarial Machine Learning (AML): “using the knowledge on how an AI
    model internally works to attack deployed models by organizations or other
    entities also via AI”
    <br />
    <br />
    Graph of Effort (GOE):
    <br />
    Foundation of the method is the modified intrusion kill chain:
    <br />
    Reconnaissance: find victims for attack.
    <br />
    Weaponization: create transferable packages with hidden malicious code.
    <br />
    Delivery: malicious package transmission to the target network.
    <br />
    Exploitation: transferred package activates its malicious code.
    <br />
    <br />
    Each step is scored (0 to 3) based on three criteria:
    <br />
    Automation Tools (AT) – Are there ready-to-use AI tools for the task?
    <br />
    Trainability of AI (TAI) – Are datasets available to train a new AI model?
    <br />
    Generability (G) – Can training data be generated automatically?
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.16357"
      >UniSync: A Unified Framework for Audio-Visual Synchronization</a
    >
    <br />
    This paper introduces UniSync, a novel method for evaluating audio-visual
    synchronization.
    <br />
    Key contributions:
    <br />
    <br />
    Unified Dual-Stream Architecture:
    <br />
    Visual stream: feature extraction -> adaptive pooling layer to scale
    features to a fixed size -> the scaled feature map is processed using a
    shared extraction layer to obtain the visual embedding. Supports RGB images,
    face parsing maps, facial landmarks, 3DMM
    <br />
    Audio stream: use specialized preprocessing layers that adapt to their
    unique characteristics while preserving essential temporal information.
    Supports Mel spectrograms, HuBERT.
    <br />
    Synchronization is assessed by cosine similarity between these embeddings.
    <br />
    <br />
    Enhanced Learning Method:
    <br />
    <br />
    Margin-Based Loss Function:
    <br />
    Used to discriminate between synchronized and unsynchronized audio-visual
    pairs.
    <br />
    It combines a margin-based binary cross-entropy loss with L2 regularization.
    <br />
    <br />
    Cross-Speaker Negative Samples
    <br />
    Introduces audio-visual mismatches across different speakers for better
    generalization
  </div>
  <v-divider></v-divider>
  <div>
    <a href="https://arxiv.org/pdf/2503.16248"
      >AI Agents in Cryptoland: Practical Attacks and No Silver Bullet
    </a>
    <br />
    This paper introduces a novel attack vector, context manipulation, a
    comprehensive attack vector that exploits unprotected context surfaces,
    including input channels, memory modules, and external data feeds
    <br />
    EzilaOS
    <br />
    Show vulnerability to prompt injection attacks that can trigger unauthorized
    crypto transfers.
    <br />
    Test state of the art prompt-based defenses fail to prevent practical memory
    injection attacks. Show memory injections can persist and propagate across
    interactions and platforms
    <br /><br />
    We formalize an AI agent’s operation as an iterative process, structured
    around four key components:
    <br />
    1. Perception Layer: The agent collects real-time data from its surroundings
    <br />
    2. Memory System: To support long-term reasoning and personalization, the
    agent maintains memory
    <br />
    3. Decision Engine:
    <br />
    Context construction: perceive real-time data about the current environment
    from the Perception Layer and retrieve relevant experiences and knowledge
    from the Memory System.
    <br />
    Goal state inference: processes and interprets the context to assess current
    objectives.
    <br />
    Action selection: select best action
    <br />
    4. Action Module: the action influences both the external environment and
    the agent’s internal state, leading to an updated context
    <br />
    Threat model:
    <br />
    1.attack objective:
    <br />
    Safety. Safety guarantees that the agent never executes an unauthorized or
    malicious action.
    <br />
    Safety attack: unauthorized action execution.
    <br />
    Liveness. Liveness ensures that the agent eventually executes any legitimate
    action when its context clearly warrants it.
    <br />
    Liveness attack: denial of service.
    <br />
    privacy:The privacy ensures that for any unauthorized entity, the
    probability of extracting any sensitive item 𝑖 ∈ 𝐼 from the system is
    negligible.
    <br />
    Privacy attack: extracting confidential information.
    <br />
    <br />
    2.focus on Safety Attack Vectors.
    <br />
    Context manipulation. Context manipulation attacks attempt to alter the
    agent’s perception of the current state or the memory of existing knowledge,
    causing it to make adversarial decisions
    <br />
    Malicious model deployment. The decision engine relies on an AI model to
    process context and select actions. This type of attack exploits weaknesses
    in the model’s architecture, causing it to misinterpret even legitimate
    inputs.
    <br />
    Action space exploitation. The action module is responsible for executing
    the chosen decision, and the security measures highly depend on the
    underlying action space. By exploiting misconfiguration or bypassing weak
    permission rules, attackers can invoke restricted functions or escalate
    allowed action set. If the action space is dynamically constructed, an
    attacker may attempt to introduce actions that should not exist.
    <br />
    3.Focus on context manipulation:
    <br />
    Direct prompt injection: For public agents such as a Discord bot, attackers
    might act as users to embed malicious instructions within normal
    conversations.
    <br />
    Indirect prompt injection: For agents that can access online information,
    the attacker might construct public data sources such as API responses or
    blockchain-derived information that contain malicious instructions.
    <br />
    Memory injection: If contextual memory is stored externally (e.g.,
    conversation history), an attacker may seek to modify this information to
    mislead the agent
    <br />
    <br />
    ElizaOS:
    <br />
    Vulnerability to Indirect Prompt Injections
    <br />
    solutions: (1) limiting the functionality of plugins to reduce risk
    exposure, or (2) maintaining full functionality while implementing
    mechanisms to resist prompt injection attacks
    <br />
    Vulnerability to Memory Injections via Prompt Injections and Database
    Modification
  </div>
</template>
<script>
export default {
  name: "readPaper",
};
</script>

<style scoped>
div {
  padding-left: 30%;
  padding-right: 30%;
  text-align: left;
}
</style>
